/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_DownloadedInputs */

const en_us2_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video saved to downloads.`)
};

const pt_br2_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo salvo nos downloads.`)
};

const es_419_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video guardado en descargas.`)
};

const pt_pt2_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo guardado nas transferências.`)
};

const fr_fr2_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo enregistrée dans les téléchargements.`)
};

const de_de2_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video in Downloads gespeichert.`)
};

const it_it2_share_video_downloaded = /** @type {(inputs: Share_Video_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video salvato nei download.`)
};

/**
* | output |
* | --- |
* | "Video saved to downloads." |
*
* @param {Share_Video_DownloadedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_downloaded = /** @type {((inputs?: Share_Video_DownloadedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_DownloadedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_downloaded(inputs)
	if (locale === "es-419") return es_419_share_video_downloaded(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_downloaded(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_downloaded(inputs)
	if (locale === "de-DE") return de_de2_share_video_downloaded(inputs)
	if (locale === "it-IT") return it_it2_share_video_downloaded(inputs)
	return en_us2_share_video_downloaded(inputs)
});
export { share_video_downloaded as "share.video_downloaded" }